__turbopack_context__.v({
  "container": "ReferralPage-module__gd7N6G__container",
  "errorContainer": "ReferralPage-module__gd7N6G__errorContainer",
  "errorText": "ReferralPage-module__gd7N6G__errorText",
  "loadingCard": "ReferralPage-module__gd7N6G__loadingCard",
  "loadingContainer": "ReferralPage-module__gd7N6G__loadingContainer",
  "loadingContent": "ReferralPage-module__gd7N6G__loadingContent",
  "loadingSpinner": "ReferralPage-module__gd7N6G__loadingSpinner",
  "loadingText": "ReferralPage-module__gd7N6G__loadingText",
  "mainContent": "ReferralPage-module__gd7N6G__mainContent",
  "shimmer": "ReferralPage-module__gd7N6G__shimmer",
  "skeletonBar": "ReferralPage-module__gd7N6G__skeletonBar",
  "skeletonContent": "ReferralPage-module__gd7N6G__skeletonContent",
  "skeletonHeading": "ReferralPage-module__gd7N6G__skeletonHeading",
  "skeletonW75": "ReferralPage-module__gd7N6G__skeletonW75",
  "skeletonW80": "ReferralPage-module__gd7N6G__skeletonW80",
  "skeletonW85": "ReferralPage-module__gd7N6G__skeletonW85",
  "skeletonW90": "ReferralPage-module__gd7N6G__skeletonW90",
  "spin": "ReferralPage-module__gd7N6G__spin",
});
